import React from "react";
import { useRevealOnScroll } from "../../hooks/useRevealOnScroll";

type RevealProps = {
  children: React.ReactNode;
  className?: string;
};

const Reveal: React.FC<RevealProps> = ({ children, className }) => {
  const { ref, visible } = useRevealOnScroll<HTMLDivElement>();
  return (
    <div ref={ref} className={`${className ?? ""} ${visible ? "animate-fade-up" : "opacity-0"}`}>
      {children}
    </div>
  );
};

export default Reveal;
